import { render, staticRenderFns } from "./LoginBackstage.vue?vue&type=template&id=26464fc2&scoped=true&"
import script from "./LoginBackstage.vue?vue&type=script&lang=js&"
export * from "./LoginBackstage.vue?vue&type=script&lang=js&"
import style0 from "./LoginBackstage.vue?vue&type=style&index=0&id=26464fc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26464fc2",
  null
  
)

export default component.exports